import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=35df0354&"
import script from "./Annotation.vue?vue&type=script&lang=js&"
export * from "./Annotation.vue?vue&type=script&lang=js&"
import style0 from "./Annotation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VDataTable})
